import { type QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRouter, type RouterHistory } from '@tanstack/react-router';
import { type RouterContext, routeTree } from './routes';
import { PendingScreen } from './routes/common';

export type { RouterContext };
export const DEFAULT_PENDING_MS = 120;
export const DEFAULT_PENDING_MIN_MS = 400;

export type HostRouterOptions = {
  queryClient: QueryClient;
  history?: RouterHistory;
};

export function createHostRouter({ queryClient, history }: HostRouterOptions) {
  return createRouter({
    routeTree,
    context: { queryClient },
    history,
    defaultPendingComponent: PendingScreen,
    defaultPendingMs: DEFAULT_PENDING_MS,
    defaultPendingMinMs: DEFAULT_PENDING_MIN_MS,
    Wrap: ({ children }) => (
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    ),
  });
}

export { routeTree };
